// 表单基础数据
export const formData = {
  houseName: '',
  houseImg: '',
  propertyTag: '',
  houseType: '',
  openingTime: '',
  areaSpace: '',
  greenSpace: '',
  GreenRate: '',
  volumeRate: '',
  propertCompany: '',
  address: '',
  remark: '',
  property: '',
  price: '',
  phone: '',
  decoration: '',
  lng: '',
  lat: '',
  sortIndex: '',
  shareHits: '',
  isOpen: true,
  isHot: true,
  leasePrice: '',
  houseH5: '',
  housePdf: '',
  roomArea: '',
  // code: '',
  source: '',
};

// 楼盘
export const formRateData = {
  type: 1,
  price: '',
  rate: '',
  commission: '',
  // rentBasePoint: '',
  expireDate: [],
};

export const formGroupData = {
  data: [
    {
      groupName: '',
      remark: '',
      info: '',
      isPlan: false,
      housePictures: [
        {
          title: '1111',
          info: '',
          area: '',
          imgUrl: '',
        },
        {
          title: '2222',
          info: '',
          area: '',
          imgUrl: '',
        },
      ],
    },
  ],
};
var validType = (rule, value, callback) => {
  let data = value.split(',');
  if (data.length > 5) {
    callback(new Error('标签不可超过5个！'));
  } else if (data.filter((item) => item.length >= 7).length > 0) {
    callback(new Error('单个标签不可超过7个字！'));
  } else {
    callback();
  }
};
// 表单验证规则
export const formRules = {
  houseName: [{ required: true, message: '楼盘不能为空', trigger: 'blur' }],
  houseImg: [{ required: true, message: '楼盘图片不能为空', trigger: 'blur' }],
  propertyTag: [
    { required: true, message: '楼盘标签不能为空', trigger: 'blur' },
    { validator: validType, trigger: 'blur' },
  ],
  houseType: [{ required: true, message: '楼盘类型不能为空', trigger: 'blur' }],
  openingTime: [
    { required: true, message: '开盘时间不能为空', trigger: 'blur' },
  ],
  areaSpace: [
    { required: true, message: ' 占地面积不能为空', trigger: 'blur' },
  ],
  greenSpace: [
    { required: true, message: '绿化面积不能为空', trigger: 'blur' },
  ],
  greenRate: [{ required: true, message: '绿化率不能为空', trigger: 'blur' }],
  volumeRate: [{ required: true, message: '容积率不能为空', trigger: 'blur' }],
  code: [{ required: true, message: '楼盘编码不能为空', trigger: 'blur' }],
  areaId: [{ required: true, message: '城市不能为空', trigger: 'blur' }],
  // property: [{ required: true, message: "产权不能为空", trigger: "blur" }],
  // price: [{ required: true, message: "参考价格不能为空", trigger: "blur" }],
  // phone: [{ required: true, message: "售楼电话不能为空", trigger: "blur" }],
  // decoration: [{ required: true, message: "装修情况不能为空", trigger: "blur" }],
  lng: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
  lat: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
  sortIndex: [{ required: true, message: '排序号不能为空', trigger: 'blur' }],
  shareHits: [
    { required: true, message: '初始分享数不能为空', trigger: 'blur' },
  ],
  houseStatus: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
};

// 表单验证规则
export const formRateRules = {
  type: [{ required: true, message: '请选择结算方式', trigger: 'blur' }],
  rate: [{ required: true, message: '售佣金比例不能为空', trigger: 'blur' }],
  price: [{ required: true, message: '楼盘总价不能为空', trigger: 'blur' }],
  commission: [
    { required: true, message: '售佣金金额不能为空', trigger: 'blur' },
  ],
  rentBasePoint_1: [
    { required: true, message: '租佣金基数不能为空', trigger: 'blur' },
  ],
  rentBasePoint_2: [
    { required: true, message: '租佣金基数不能为空', trigger: 'blur' },
  ],
  expireDate: [{ required: true, message: '有效期不能为空', trigger: 'blur' }],
};
